var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"loading-spinner",style:(_vm.spinnerStyle)},_vm._l((12),function(n){return _c('div',{key:n,staticClass:"spinner-blade",style:({
        transform: `rotate(${(n - 1) * 30}deg)`,
        animationDelay: `${(n - 1) * 0.1}s`,
      })})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }